// InvokedSkillsBar.jsx — pills pras skills invocadas via `/` no composer.
//
// Sprint v8.3 → 2026-07-08: a skill invocada NÃO fica mais como /texto cru no
// textarea. Ao pickar no `/`, ela SAI do texto e vira uma pill aqui (o composer
// reinjeta os /comandos no prompt no envio — mesmo padrão dos anexos e das
// Design pills). Recebe `skills` (array de comandos) + `onRemove(slash_command)`.
//
// Identidade por COR (sem ícone): cada pill herda a cor do plugin/namespace,
// igual ao seletor "/" e ao ⌘K.

import { Plug, X } from 'lucide-react';
import { pluginColor, withAlpha } from '../../lib/pluginColor.js';

export default function InvokedSkillsBar({ skills, onRemove }) {
  if (!Array.isArray(skills) || skills.length === 0) return null;

  return (
    <div aria-label="Skills invocadas" className="flex flex-wrap gap-1.5 pt-1.5">
      <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wide text-apolo-textTertiary">
        <Plug size={9} aria-hidden="true" />
        Invocadas
      </span>
      {skills.map((cmd) => {
        const color = pluginColor(cmd.plugin_slug);
        const slash = cmd.slash_command;
        return (
          <span
            key={slash}
            className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-medium text-apolo-textPrimary backdrop-blur-md transition"
            style={{
              borderColor: withAlpha(color, 0.4),
              backgroundColor: withAlpha(color, 0.13),
              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.08)',
            }}
            title={`${cmd.display_name} · ${cmd.plugin_display_name || cmd.plugin_slug}`}
          >
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 shrink-0 rounded-full"
              style={{ backgroundColor: color, boxShadow: `0 0 4px ${withAlpha(color, 0.5)}` }}
            />
            <code className="font-mono text-[10px]">{slash}</code>
            <button
              type="button"
              onClick={() => onRemove?.(slash)}
              aria-label={`Remover ${slash}`}
              className="ml-0.5 rounded-full text-apolo-textTertiary transition hover:bg-apolo-bg/40 hover:text-apolo-error"
            >
              <X size={10} aria-hidden="true" />
            </button>
          </span>
        );
      })}
    </div>
  );
}
